@if(loaded){
<mat-form-field
  class="mb2 mt1 inputbox"
  hideRequiredMarker="true">
  <mat-label>Search...</mat-label>
  <input
    matInput
    [formControl]="filterInputControl" />
  @if(filterInputControl.invalid){
  <mat-error
    color="warn"
    class="textFont">
    Invalid input</mat-error
  >
  }
</mat-form-field>

@if (!hideChips()) {
<div class="chipContainer">
  <mat-chip-listbox class="mb2">
    @for (row of selectedRows; track $index) {
    <mat-chip-option
      [selectable]="false"
      (removed)="onRowClick(row)"
      class="text-overflow"
      >{{ row.displayName }}
      <button
        matChipRemove
        (clicked)="onRowClick(row)">
        <mat-icon class="chipIcon">cancel</mat-icon>
      </button>
    </mat-chip-option>
    }
  </mat-chip-listbox>
</div>
} @if (!hideChips() && (selectedRows.length || selectedRowsGroups.length)) {
<div class="removeAllContainer p1">
  Remove all
  <button
    mat-button
    class="delete-button"
    matTooltip="Remove all"
    (click)="removeAll()">
    <mat-icon>cancel</mat-icon>
  </button>
</div>
}
<div class="tableContainer mt4">
  @if (dataSource.data.length) {
  <table
    mat-table
    #table
    matSort
    (matSortChange)="sortData($event)"
    [dataSource]="dataSource"
    class="fullWidth">
    <ng-container matColumnDef="checkbox">
      <th
        mat-header-cell
        *matHeaderCellDef></th>
      <td
        mat-cell
        *matCellDef="let element"
        class="pr2">
        <mat-checkbox
          class="pointer"
          [checked]="checkIfExistsInSelectedRows(element)"></mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="firstName">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef>
        Firstname
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="text-overflow">
        {{ element.id | userName : 'firstName' | async }} {{ element.id | azureIdStatus | async }}
      </td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef>
        Lastname
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="text-overflow">
        {{ element.id | userName : 'lastName' | async }} {{ element.id | azureIdStatus | async }}
      </td>
    </ng-container>
    <ng-container matColumnDef="mail">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef>
        Mail
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="text-overflow">
        {{ element.mail }}
      </td>
    </ng-container>
    <tr
      mat-header-row
      *matHeaderRowDef="columnDef"></tr>
    <tr
      class="pointer"
      mat-row
      (click)="onRowClick(row)"
      *matRowDef="let row; columns: columnDef"></tr>
  </table>
  }
</div>
}
